import React, {Fragment} from "react"
import {Link} from "react-router-dom"


const handleSubmit =(e)=>{
    e.preventDefault();
}

const Login = () => {
    return (
        <Fragment>
            <form className="widget-form p-0" action="#" onSubmit={handleSubmit}>
                <div className="input-box mb-30">
                    <input type="text" placeholder="Usuario"/>
                </div>
                <div className="input-box mail mb-30">
                    <input type="email" placeholder="Correo Electrónico"/>
                </div>
                <div className="input-box pass mb-30">
                    <input type="text" placeholder="Contraseña"/>
                </div>
                <div className="col-12 text-center">
                    <button className="theme_btn">Iniciar Sesión</button>
                    <span className="divider">O</span>
                    <button className="theme_btn signup-btn"><img className="mr-20" src="assets/img/icon/google.svg" alt="icon" /> Iniciar Sesión con Google</button>
                    <p className="text-white fw-regular mt-40 mb-10">¿No tienes una cuenta?  <Link to="/signup" className="fw-semi">Regístrate Hoy</Link></p>
                    <a href="#" className="fw-semi text-white fw-semi">¿Olvidaste tu contraseña?</a>
                </div>
            </form>
        </Fragment>
    )
}

export default Login